// Carries the client-side context of a request to the API route handling it, so the event a route logs can be
// correlated with the event the client logs for the same failure. Node lowercases incoming header names.
export const CLIENT_CONTEXT_HEADER = 'x-bolt-client-context'
